import React, { createContext } from "react"
import type { PeriodoEntregaFornecedorModel } from "../models/periodoEntregaFornecedorModel"
import type { PeriodoEntregaFornecedorActionModel } from "./periodoEntregaFornecedorActions"
import { PeriodoEntregaFornecedorInicial } from "../models/periodoEntregaFornecedorModel"

type PeriodoEntregaFornecedorContextType = {
    dados: PeriodoEntregaFornecedorModel
    dispatch: React.Dispatch<PeriodoEntregaFornecedorActionModel>
    erroCarregamento: string | null
}

export const PeriodoEntregaFornecedorContext = createContext<PeriodoEntregaFornecedorContextType>({
    dados: PeriodoEntregaFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
